/**
 * Serializes a plain message payload for sending.
 *
 * Format:
 * - 1 byte: version (currently 1)
 * - 2 bytes: message length prefix (uint16, big-endian)
 * - N bytes: message content (UTF-8 encoded)
 *
 * @param message - The message to serialize
 * @returns A Uint8Array representing the serialized message payload
 */
export function serializeMessagePayload(message: string): Uint8Array {
  const encoder = new TextEncoder();
  const messageBytes = encoder.encode(message);

  if (messageBytes.length > 0xffff) {
    throw new Error(`Message exceeds maximum 65535 bytes after UTF-8 encoding`);
  }

  const buffer = new Uint8Array(1 + 2 + messageBytes.length);
  let offset = 0;

  // Version
  buffer[offset++] = 1;

  // Length prefix (uint16, big-endian)
  buffer[offset++] = (messageBytes.length >> 8) & 0xff;
  buffer[offset++] = messageBytes.length & 0xff;

  // Message content
  buffer.set(messageBytes, offset);

  return buffer;
}